import noop from 'lodash/noop';
import type { FunctionComponent, PropsWithChildren } from 'react';
import { createContext, useContext, useMemo, useRef } from 'react';

export type CommentsToggleFocusRegistry = {
    readonly registerCommentsToggle: (node: HTMLElement | null) => void;
    readonly focusCommentsToggle: () => void;
};

const CommentsToggleFocusContext = createContext<CommentsToggleFocusRegistry | null>(null);

const NOOP_REGISTRY: CommentsToggleFocusRegistry = {
    registerCommentsToggle: noop,
    focusCommentsToggle: noop,
};

export const CommentsToggleFocusProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const toggleRef = useRef<HTMLElement | null>(null);

    const registry = useMemo<CommentsToggleFocusRegistry>(
        () => ({
            registerCommentsToggle: (node) => {
                toggleRef.current = node;
            },
            focusCommentsToggle: () => {
                toggleRef.current?.focus();
            },
        }),
        [],
    );

    return <CommentsToggleFocusContext.Provider value={registry}>{children}</CommentsToggleFocusContext.Provider>;
};

export const useCommentsToggleFocus = (): CommentsToggleFocusRegistry =>
    useContext(CommentsToggleFocusContext) ?? NOOP_REGISTRY;
